import React from 'react';
import { Search, Filter, X } from 'lucide-react';

const NotificationFilters = ({ filters, onFilterChange }) => {
  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    onFilterChange(newFilters);
  };

  const handleReset = () => {
    const resetFilters = {
      search: '',
      type_notification: '',
      type_cible: '',
      priorite: '',
      est_envoyee: '',
      est_programmee: '',
      ordering: '-created_at'
    };
    onFilterChange(resetFilters);
  };

  const typesNotification = [
    { value: 'INFO', label: 'Information' },
    { value: 'AVERTISSEMENT', label: 'Avertissement' },
    { value: 'URGENCE', label: 'Urgence' },
    { value: 'FELICITATION', label: 'Félicitation' },
    { value: 'RAPPEL', label: 'Rappel' },
    { value: 'EVENEMENT', label: 'Événement' }
  ];

  const typesCible = [
    { value: 'TOUS', label: 'Tous les utilisateurs' },
    { value: 'CIBLÉ', label: 'Utilisateurs ciblés' },
    { value: 'GROUPE', label: 'Groupe spécifique' }
  ];

  const priorites = [
    { value: 'BASSE', label: 'Basse' },
    { value: 'NORMALE', label: 'Normale' },
    { value: 'HAUTE', label: 'Haute' },
    { value: 'CRITIQUE', label: 'Critique' }
  ];

  const triOptions = [
    { value: '-created_at', label: 'Plus récentes' },
    { value: 'created_at', label: 'Plus anciennes' },
    { value: '-priorite', label: 'Priorité (haute à basse)' },
    { value: 'priorite', label: 'Priorité (basse à haute)' },
    { value: 'titre', label: 'Titre (A-Z)' },
    { value: '-titre', label: 'Titre (Z-A)' }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Filter className="w-5 h-5 text-[#FF6B00]" />
          <h3 className="text-lg font-semibold text-gray-900">Filtres</h3>
        </div>
        <button
          onClick={handleReset}
          className="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <X className="w-4 h-4" />
          Réinitialiser
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {/* Recherche */}
        <div className="lg:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Rechercher
          </label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Titre ou message..."
              value={filters.search || ''}
              onChange={(e) => handleFilterChange('search', e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
            />
          </div>
        </div>

        {/* Type de notification */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Type
          </label>
          <select
            value={filters.type_notification || ''}
            onChange={(e) => handleFilterChange('type_notification', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          >
            <option value="">Tous les types</option>
            {typesNotification.map(type => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>

        {/* Type de cible */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Cible
          </label>
          <select
            value={filters.type_cible || ''}
            onChange={(e) => handleFilterChange('type_cible', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          >
            <option value="">Toutes les cibles</option>
            {typesCible.map(type => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>

        {/* Priorité */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Priorité
          </label>
          <select
            value={filters.priorite || ''}
            onChange={(e) => handleFilterChange('priorite', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          >
            <option value="">Toutes les priorités</option>
            {priorites.map(priorite => (
              <option key={priorite.value} value={priorite.value}>
                {priorite.label}
              </option>
            ))}
          </select>
        </div>

        {/* Statut envoi */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Statut d'envoi
          </label>
          <select
            value={filters.est_envoyee || ''}
            onChange={(e) => handleFilterChange('est_envoyee', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          >
            <option value="">Tous</option>
            <option value="true">Envoyées</option>
            <option value="false">Non envoyées</option>
          </select>
        </div>

        {/* Programmation */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Programmation
          </label>
          <select
            value={filters.est_programmee || ''}
            onChange={(e) => handleFilterChange('est_programmee', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          >
            <option value="">Toutes</option>
            <option value="true">Programmées</option>
            <option value="false">Non programmées</option>
          </select>
        </div>

        {/* Tri */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Trier par
          </label>
          <select
            value={filters.ordering || '-created_at'}
            onChange={(e) => handleFilterChange('ordering', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          >
            {triOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default NotificationFilters;
